import Chair from '@mui/icons-material/Chair'
import HelpOutline from '@mui/icons-material/HelpOutline'
import Home from '@mui/icons-material/Home'
import VideoCameraFront from '@mui/icons-material/VideoCameraFront'
import {
  SESSION_PLATFORM_HOME_VISIT,
  SESSION_PLATFORM_OFFLINE,
  SESSION_PLATFORM_ONLINE,
} from 'src/consumer/constants'

const CURRENCY_SYMBOLS = { inr: '₹', usd: '$', eur: '€', gbp: '£' }

function firstPresent(...values) {
  return values.find((value) => value !== undefined && value !== null && value !== '')
}

function getPrimaryPricingDetail(pricingMatrix) {
  if (!pricingMatrix) return null
  if (typeof pricingMatrix !== 'object') return null
  if (pricingMatrix?.row) return pricingMatrix.row
  if (pricingMatrix?.ROW) return pricingMatrix.ROW
  return Object.values(pricingMatrix).find(Boolean) || null
}

export function getMeetingSrcLabel(meetingSrc) {
  if (meetingSrc === SESSION_PLATFORM_OFFLINE) return 'In Person'
  if (meetingSrc === SESSION_PLATFORM_ONLINE) return 'Video Call'
  if (meetingSrc === SESSION_PLATFORM_HOME_VISIT) return 'Home Visit'
  return 'Mode unknown'
}

export function getMeetingSrcIcon(meetingSrc, { size = 18, color, sx: extraSx } = {}) {
  const sx = {
    fontSize: typeof size === 'number' ? `${size}px` : size,
    ...(color ? { color } : {}),
    ...(extraSx || {}),
  }
  if (meetingSrc === SESSION_PLATFORM_OFFLINE) {
    return <Chair sx={sx} titleAccess="In Person" />
  }
  if (meetingSrc === SESSION_PLATFORM_ONLINE) {
    return <VideoCameraFront sx={sx} titleAccess="Video Call" />
  }
  if (meetingSrc === SESSION_PLATFORM_HOME_VISIT) {
    return <Home sx={sx} titleAccess="Home Visit" />
  }
  return <HelpOutline sx={sx} titleAccess="Mode unknown" />
}

export function formatEventFeeLabel(eventOrBooking, pricingPlan) {
  if (!eventOrBooking && !pricingPlan) return ''
  if (eventOrBooking?.free || pricingPlan?.free) return 'Free'
  const pricingDetail = getPrimaryPricingDetail(
    pricingPlan?.pricingMatrix || eventOrBooking?.pricingMatrix,
  )
  const price = firstPresent(
    pricingDetail?.discountedPrice,
    pricingPlan?.finalPrice,
    pricingPlan?.discountedPrice,
    eventOrBooking?.finalPrice,
    eventOrBooking?.discountedPrice,
    pricingPlan?.price,
    pricingDetail?.price,
    eventOrBooking?.price,
    eventOrBooking?.defaultPrice,
    eventOrBooking?.feePaid,
  )
  const currency = (
    firstPresent(
      pricingDetail?.currencyId,
      pricingPlan?.currency,
      pricingPlan?.defaultCurrency,
      eventOrBooking?.defaultCurrency,
      eventOrBooking?.currency,
    ) || ''
  )
    .toString()
    .toLowerCase()
  if (price == null || price === '' || Number(price) <= 0) return ''
  const explicitSymbol = firstPresent(
    pricingDetail?.currencySymbol,
    pricingPlan?.currencySymbol,
    eventOrBooking?.currencySymbol,
  )
  const symbol = explicitSymbol || CURRENCY_SYMBOLS[currency] || (currency ? currency.toUpperCase() + ' ' : '')
  return `${symbol}${price}`
}
